@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.phoneSelectLabel {
  color: v.$white-color;
  @include t.text(10px, 120%, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.phoneSelectInputWrapper {
  position: relative;
}

.phoneFieldShell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 6px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.phoneFieldShell--embedded {
  min-height: 0;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.phoneSelectWrapper {
  margin-bottom: 32px;
}

.phoneFieldDivider {
  flex-shrink: 0;
  width: 1px;
  height: 32px;
  background: v.$gray-light-color;
}

.phoneFieldInputWrap {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  input::placeholder {
    color: v.$gray-dark-color;
  }
}

.phoneSelectLableWrapper {
  display: flex;
}

.list {
  padding: 4px 8px;
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 6px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  box-shadow: v.$shadow-dropdown;
  z-index: 4;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  color: v.$white-color;
  @include t.text(14px, 22px, "normal");

  &:hover {
    background-color: v.$gray-border-color;
  }
}

/* Chinese Brothers */

.phoneFieldShell--chinese-brothers {
  border-color: v.$chinese-brothers-input-border;
  background: v.$chinese-brothers-input-bg;

  &:hover {
    border-color: v.$chinese-brothers-input-border-hover;
  }

  &:focus-within {
    border-color: v.$chinese-brothers-input-border-active;
  }

  &.phoneFieldShell--invalid {
    border-color: v.$chinese-brothers-input-border-error;
  
    &:hover {
      border-color: v.$chinese-brothers-input-border-error;
    }
  
    &:focus-within {
      border-color: v.$chinese-brothers-input-border-error;
      box-shadow: v.$shadow-focus-red;
    }
  }

  .phoneFieldShell--embedded {  
    &:hover {
      border-color: transparent;
    }
  
    &:focus-within {
      outline: none;
      border: none;
      box-shadow: none;
    }
  
    &.phoneFieldShell--invalid {
      border-color: v.$chinese-brothers-input-border-error;
      box-shadow: none;
  
      &:hover,
      &:focus-within {
        border-color: v.$chinese-brothers-input-border-error;
        box-shadow: none;
      }
    }
  }
}

/* Qubictron */

.phoneFieldShell--qubictron {
  &:not(.phoneFieldShell--invalid):hover {
    border-color: v.$green-dark-color;
  }

  &:not(.phoneFieldShell--invalid):focus-within {
    outline: none;
    border-color: v.$green-color;
  }

  &.phoneFieldShell--invalid {
    border-color: v.$error-color;
  
    &:hover {
      border-color: v.$error-color;
    }
  
    &:focus-within {
      outline: none;
      border-color: v.$error-color;
      box-shadow: v.$shadow-focus-red;
    }
  }

  .phoneFieldShell--embedded {  
    &:hover {
      border-color: transparent;
    }
  
    &:focus-within {
      outline: none;
      border: none;
      box-shadow: none;
    }
  
    &.phoneFieldShell--invalid {
      border-color: transparent;
      box-shadow: none;
  
      &:hover,
      &:focus-within {
        border-color: transparent;
        box-shadow: none;
      }
    }
  }
}